<template src="./IdiMeet.html"></template>

<script>
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import LiveKitRoom from "@/components/LiveKit/LiveKitRoom.vue";
import idiService from "@/services/Idi";
import { mapGetters } from "vuex";

export default {
  name: "idi-meet",
  components: {
    ArrobaMedellinArrobitaNoData,
    LiveKitRoom,
  },
  data() {
    return {
      role: "",
      eventIdi: null,
      eventid: "",
      roomName: "",
      showAudioText: "Activar Microfono",
      shareScreenText: "Compartir Pantalla",
      isComponentModalActive: true,
    };
  },

  created() {
    this.role = this.$store.state.User.user.role.name;
    this.getInitData();
  },

  methods: {
    async getInitData() {
      await this.getEventIdi();
      this.eventid = this.$route.params.idEvent;
    },

    async getEventIdi() {
      this.eventIdi = await idiService.listOneGroup(this.$route.params.idEvent);
      this.validateCode();
    },

    async validateCode() {
      const validate = await idiService.userGroupParticipant(
        this.$route.params.idEvent
      );
      if (validate.participant) {
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: "Ingresando a grupo!",
          type: "is-success",
        });
        this.createdJetsi(this.eventIdi);
      } else {
        this.$buefy.toast.open({
          duration: 5000,
          position: "is-bottom",
          message: "No posees permiso para ingresar",
          type: "is-danger",
        });
        setTimeout(() => {
          this.$router.go(-1);
        }, 3000);
      }
    },
    createdJetsi(event) {
      // Establecer el nombre de la sala para LiveKit
      this.roomName = event.meetUrl;
      this.$buefy.toast.open({
        duration: 5000,
        position: "is-bottom",
        message: "Ingreso a la sala con exito!",
        type: "is-success",
      });
      this.isComponentModalActive = false;
    },
    buttonshowAudio() {
      if (this.$refs.livekitRoom) {
        this.$refs.livekitRoom.toggleAudio();
      }
    },

    buttonShareScreen() {
      if (this.$refs.livekitRoom) {
        this.$refs.livekitRoom.toggleScreenShare();
      }
    },
    // Eventos de LiveKit
    onLiveKitConnected(room) {
      console.log("Conectado a LiveKit:", room);
    },
    onLiveKitDisconnected() {
      console.log("Desconectado de LiveKit");
    },
    onLeaveRoom() {
      this.$router.go(-1);
    },
  },

  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    roleValidationNoAccess() {
      return ["Student"].some((a) => a === this.role);
    },
  },
};
</script>

<style lang="scss" scoped src="./IdiMeet.scss"></style>
